import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work10MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail1 from './image/workThumbnails/thumbnail1.webp';
import { WorkImage } from './workDetailPage/WorkImage';
import background from './image/works/work10background.webp';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import problem1 from './image/works/work10problem1.webp';
import problem2 from './image/works/work10problem2.webp';
import problem3 from './image/works/work10problem3.webp';
import problem4 from './image/works/work10problem4.webp';
import solution1 from './image/works/work10solution1.webp';
import solution2 from './image/works/work10solution2.webp';
import solution3 from './image/works/work10solution3.webp';
import revise from './image/works/work10 Revised structure.webp';
import past from './image/works/work10 Past structure.webp';
import solution11 from './image/works/work10solution1-1.webp';
import solution22 from './image/works/work10solution2-2.webp';
import solution33 from './image/works/work10solution33.webp';
import { Divider } from '@mui/material';
import result1 from './image/works/work10result1.webp';
import result2 from './image/works/work10result2.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//EliminatingConcernsofCreatingAds

function Work10(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'Eliminating Concerns of Creating Ads - Lynkim',
      description: 'Encouraging ad creation to increase the activation rate.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'Eliminating Concerns of Creating Ads'} 
          description={'Encouraging ad creation to increase the activation rate.'} 
          team={'Karrot(Daangn)'} 
          role={'Service Planning, UXUI Design, Data Experiment'} 
          period={'2023.01. - 2023.03.'}
          titleKo={'광고 만들기 망설임 해소'}
          descriptionKo={'광고 생성 활성화를 높이기 위해, 사용자가 망설이는 지점을 개선했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'서비스 기획, UXUI 디자인, 데이터 실험'}
        />
      </div>
      <MainImage image={mainImage}/>
      <Divider/>
      <WorkTextSection 
        title='Background' 
        description='Among the advertisers who have created an ad account, 36% have never created an ad. To encourage them to create ads, we analyzed the issues with the current design and proposed various ideas.'
        subDescription={'광고 계정을 생성한 광고주 중 36%는 한 번도 광고를 만든 적이 없습니다. 광고 생성을 유도하기 위해 기존 디자인의 문제를 분석하고 여러 개선 아이디어를 제안했습니다.'}
      />
      <WorkFullImage image={background}  isMargin={true} isBottomMargin={true}/>
      <div style={{backgroundColor:'var(--color-bg-soft)'}}>
        <WorkTextSection 
          title='Problem 1.' 
          description={'The rate of clicking on "Create Ad" was very low at 29%, and the completion rate for those who attempted to create an ad was also very low at 34%.'}
          subDescription={'"광고 만들기" 클릭률은 29%로 매우 낮았고, 시도한 사용자들의 광고 생성 완료율도 34%로 낮았습니다.'}
        />
        <div className={'margin48'} style={{margin:"auto", maxWidth:"1600px", alignContent: "center", display: "flex", flexDirection: "row", gap:"40px", marginBottom:'60px'}}>
            <WorkFullImage image={problem1} />     
            <WorkFullImage image={problem2} />        
        </div>
        <WorkTextSection 
          title='Problem 2.' 
          description={"After drafting ad posts, most advertisers have launched their ads within 1 to 2 days. This indicates that advertisers decide on whether to run an ad within 2 days of creating the post. It's important to reflect this behavior pattern when selecting ad creatives."}
          subDescription={'광고 게시물을 초안한 뒤 대부분의 광고주가 1~2일 내에 광고를 집행했습니다. 이는 게시물 작성 후 2일 이내에 집행 여부를 결정한다는 뜻이며, 크리에이티브 선택 단계에서 이 행동 패턴을 반영하는 것이 중요합니다.'}
        />
        <div className={'margin48'} style={{margin:"auto", maxWidth:"1600px", alignContent: "center", display: "flex", flexDirection: "row", gap:"40px", marginBottom:'120px'}}>
            <WorkFullImage image={problem3} />     
            <WorkFullImage image={problem4} />        
        </div>
      <Divider/>
      </div>
      <WorkTextSection 
        title='Solution 1.' 
        description={"Encouraging ad creation on empty page"}
        subDescription={'비어 있는 페이지에서 광고 생성을 유도합니다.'}
      />
      <WorkFullImage image={solution1} />   
      <WorkFullImage image={solution11} /> 
      <Divider/>
      <WorkTextSection 
        title='Solution 2.' 
        description={"Recommend ad creatives during the selection phase"}
        subDescription={'선택 단계에서 광고 크리에이티브를 추천합니다.'}
      />
      <WorkFullImage image={solution2} isBottomMargin={true} />   
      <div className={'margin48'} style={{margin:"auto", maxWidth:"1600px", alignContent: "center", display: "flex", flexDirection: "row", gap:"40px", marginBottom:'60px'}}>
            <WorkFullImage image={past} isBorder={true} isRoundedCorner={true} isShadow={true} />     
            <WorkFullImage image={revise} isBorder={true} isRoundedCorner={true} isShadow={true}/>        
        </div>
        <WorkFullImage image={solution22} isBottomMargin={true} /> 
        <Divider/>
      <WorkTextSection 
        title='Solution 3.' 
        description={"Guide proper actions on the ad manager"}
        subDescription={'광고 관리자에서 올바른 행동을 안내합니다.'}
      />
      <WorkFullImage image={solution3} isBottomMargin={false} />
      <WorkFullImage image={solution33} isBottomMargin={true} /> 
      <Divider/>
      <WorkTextSection 
          title='Result' />
      <div className='image-center margin48 horizontal-layout'>
        <WorkFullImage image={result1} isMargin={false} isBottomMargin={true} />   
        <WorkFullImage image={result2} isMargin={false} isBottomMargin={true} />   
      </div>  
      <BackButton/>
      <NextItem to='/Work1' thumbnail={thumbnail1} nextProjectTitle='New Ads Platform for Experts'/>
      <div style={{ height: "400px" }} />
      </>
      // </ProtectedPage>
    )
}

export default Work10;
